const init = {
  caseType: null,
  make: null,
  model: null,
  modelUrl: '',
  catalogUrl: '',
  product: {},
  subProduct: {},
  category: {},
  catalog: {}
};

const reducer = (state = init, action) => {
  switch (action.type) {
    case 'CASETYPE':
      return {
        ...state,
        caseType: action.payload
      };
    case 'MAKE':
      return {
        ...state,
        make: action.payload
      };
    case 'MODEL':
      return {
        ...state,
        model: action.payload
      };

    case 'MODELURL':
      return {
        ...state,
        modelUrl: action.payload
      };

    case 'CATALOGURL':
      return {
        ...state,
        catalogUrl: action.payload
      };

    case 'CATALOG':
      return {
        ...state,
        catalog: action.payload
      };

    case 'PRODUCT':
      return {
        ...state,
        product: action.payload
      };

    case 'SUBPRODUCT':
      return {
        ...state,
        subProduct: action.payload
      };

    case 'CATEGORY':
      return {
        ...state,
        category: action.payload
      };

    case 'DESIGNER':
      return {
        ...state,
        catalogUrl: action.catalogUrl,
        modelUrl: action.modelUrl,
        model: action.model,
        make: action.make,
        caseType: action.caseType,
        product: action.product,
        subProduct: action.subProduct,
        catalog: action.catalog
      };
    default:
      return state;
  }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/reducers/designer.reducer.js